module.exports = "/dist/img/giftshopper_fabric3.5767fd35.jpg";